import React from "react";

import {
  IssueIcon,
  NoIssueIcon,
  WarningIcon,
  GuidanceIcon,
} from "constants/icons";
import issueHeaderUtils from "utils/issues/issue_header_utils";
import {RagState} from "common/types/issue";

// Same icons and colours as the issue state selector
const RAG_ICONS: Record<
  RagState,
  {Icon: React.ElementType; color: string; label: string}
> = {
  Red: {Icon: IssueIcon, color: "red0", label: "Issue"},
  Amber: {Icon: WarningIcon, color: "amber0", label: "Warning"},
  Green: {Icon: NoIssueIcon, color: "green0", label: "No issue"},
  Grey: {Icon: GuidanceIcon, color: "grey0", label: "Guidance"},
};

interface RagStateIconProps {
  state: string;
}

export default function RagStateIcon({state}: RagStateIconProps) {
  const rag = RAG_ICONS[state as RagState];
  if (!rag) {
    return null;
  }
  const {Icon, color, label} = rag;
  return (
    <span title={label} aria-label={label} style={{float: "right"}}>
      <Icon
        style={{
          width: 18,
          height: 18,
          verticalAlign: "middle",
          color: issueHeaderUtils.colors[color],
        }}
      />
    </span>
  );
}
